import * as types from './company-contexts.types';
import * as constants from './company-contexts.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeCompanyContext = generateStoreResourceAction<types.ICompanyContext>(constants.STORE_COMPANY_CONTEXT);
export const clearCompanyContext = generateClearResourceAction(constants.CLEAR_COMPANY_CONTEXT);
